module.exports = {
      id: "Pinterest-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/simulator/sprite.svg#Pinterest-usage",
      toString: function () {
        return this.url;
      }
    }